export default __webpack_public_path__ + "static/media/rocket_anim_137.e32293d4.png";